import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export interface FiltroAplicadoTag {
  key: string;
  label: string;
  /** Valor opcional do filtro, útil quando a mesma key aparece mais de uma vez. */
  valor?: any;
}

@Component({
  selector: 'app-filtros-aplicados',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './filtros-aplicados.component.html',
  styleUrl: './filtros-aplicados.component.scss',
})
export class FiltrosAplicadosComponent {
  @Input() tags: FiltroAplicadoTag[] = [];
  @Input() rotulo = 'Filtros aplicados:';
  /** null = automático (exibe quando há mais de uma tag). */
  @Input() mostrarLimpar: boolean | null = null;
  @Input() rotuloLimpar = 'Limpar filtros';

  @Output() remover = new EventEmitter<FiltroAplicadoTag>();
  @Output() limpar = new EventEmitter<void>();

  @HostBinding('style.display')
  get display(): string {
    return this.tags.length ? 'flex' : 'none';
  }

  get exibirLimpar(): boolean {
    return this.mostrarLimpar ?? this.tags.length > 1;
  }
}
